// eslint-disable-next-line no-unused-vars
import React, { cloneElement } from 'react';
import { bool, func, node, string, array } from 'prop-types';

import useImage, { imagePromiseFactory } from 'Hooks/useImage';

const defaultContainer = x => x;

const Img = (
{
    decode = true,
    src: srcList = [],
    loader = null,
    unloader = null,
    container = defaultContainer,
    loaderContainer = defaultContainer,
    unloaderContainer = defaultContainer,
    imgPromise,
    crossorigin,
    useSuspense = false,
    ...imgProps // anything else will be passed to the <img> element
  }) => {
  // eslint-disable-next-line no-param-reassign
  imgPromise = imgPromise || imagePromiseFactory({ decode, crossOrigin: crossorigin });
  const { src, error, isLoading } = useImage({
    srcList,
    imgPromise,
    useSuspense
  });

  if (error && unloader) {
    return unloaderContainer(cloneElement(unloader, imgProps));
  }

  // show img if loaded
  if (src) {
    return container(<img src={ src } alt="" { ...imgProps } />);
  }

  // show loader if we have one and were still trying to load image
  if (!useSuspense && isLoading) {
    return loaderContainer(loader);
  }

  // show unloader if we have one and we have no more work to do
  if (!useSuspense && unloader) {
    return unloaderContainer(cloneElement(unloader, imgProps));
  }

  return null;
};

Img.propTypes = {
  decode: bool,
  src: array,
  loader: node,
  unloader: node,
  container: func,
  loaderContainer: func,
  unloaderContainer: func,
  imgPromise: func,
  crossorigin: string,
  useSuspense: bool,
};

export default Img;
